import React from 'react';

import { DateFormatter } from 'app/utils/columnsFormatters/DateFormatter';
import { useIntl } from 'react-intl';
import { TrackingStatusFormatter } from 'app/utils/columnsFormatters/TrackingStatusFormatter';
import { getGroupedStatus } from 'app/hooks/useTrackingsStatus.hook';
import Link from 'app/components/Link';

export function GetColDataTable() {
  const intl = useIntl();

  const columnsArray = [
    {
      dataField: 'id',
      text: '',
      hidden: true,
      sort: false
    },
    {
      dataField: 'statusKey',
      text: intl.formatMessage({ id: 'controlpanel.global.filter.status' }),
      sort: true,
      hidden: false,
      formatter: (cell, formatExtraData) => (
        <TrackingStatusFormatter
          status={cell}
          possibleDelay={formatExtraData?.possibleDelay}
        />
      )
    },
    {
      dataField: 'dateStatus',
      text: intl.formatMessage({
        id: 'controlpanel.trackings.table.last_update'
      }),
      sort: true,
      hidden: false,
      formatter: (cell, formatExtraData) => {
        const text =
          formatExtraData?.possibleDelay === true
            ? intl.formatMessage({
                id: 'controlpanel.trackings.table.delay'
              })
            : formatExtraData?.description;
        return (
          <div className="tracking-datatable__last-update">
            <DateFormatter date={cell} />
            {text && <div className="description">{text}</div>}
          </div>
        );
      },
      style: {
        maxWidth: '250px'
      }
    },
    {
      dataField: 'carrier',
      text: intl.formatMessage({ id: 'controlpanel.orders.table.carrier' }),
      sort: true,
      hidden: false
    },
    {
      dataField: 'tracking',
      text: intl.formatMessage({ id: 'controlpanel.trackings.table.tracking' }),
      sort: true,
      hidden: false,
      formatter: (cell, formatExtraData) => (
        <Link
          href={formatExtraData.trackingUrl}
          text={cell}
          target="_blank"
          tooltipText={`${intl.formatMessage({
            id: 'controlpanel.global.view_tracking_on'
          })} ${formatExtraData.carrier}`}
        />
      )
    }
  ];

  return columnsArray;
}

export const getDataTableStructure = (data) =>
  data.map(
    ({
      id,
      attributes: {
        statusKey,
        dateStatus,
        lastUpdate,
        carrier,
        tracking,
        deliveryNoteNumber,
        orderId,
        deliveryNoteId,
        trackingUrl,
        carrierStatus,
        possibleDelay
      }
    }) => ({
      id,
      dateStatus,
      statusKey,
      lastUpdate,
      carrier,
      tracking,
      deliveryNoteNumber,
      orderId,
      deliveryNoteId,
      trackingUrl,
      description: carrierStatus,
      possibleDelay
    })
  );

export const rowClasses = (row) => {
  const statusRow = row?.status;
  const { DELIVERY_EXCEPTION, OTHER_EXCEPTION } = getGroupedStatus();

  if ([...DELIVERY_EXCEPTION, ...OTHER_EXCEPTION].includes(statusRow)) {
    return 'red';
  }
  return null;
};
